import { useState, type InputHTMLAttributes } from "react";
import { Eye, EyeOff } from "lucide-react";
import { IconButton, Input } from "../ui";

/** A password field with a button that shows or hides what's typed. */
export const PasswordInput = ({
  className = "",
  ...props
}: Omit<InputHTMLAttributes<HTMLInputElement>, "type">) => {
  const [visible, setVisible] = useState(false);
  return (
    <span className="relative block">
      <Input
        {...props}
        className={`pr-12 font-normal ${className}`}
        inputSize="lg"
        type={visible ? "text" : "password"}
      />
      <IconButton
        aria-label={visible ? "Hide password" : "Show password"}
        aria-pressed={visible}
        className="absolute top-1/2 right-1.5 -translate-y-1/2"
        onClick={() => setVisible(!visible)}
      >
        {visible ? <EyeOff size={18} /> : <Eye size={18} />}
      </IconButton>
    </span>
  );
};
